import React from 'react';

function PageLoader({ label = 'Loading…' }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '20px',
        color: 'var(--on-surface-variant)',
      }}
    >
      {/* Concentric ring spinner — brand maroon + gold */}
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        aria-hidden="true"
        style={{ animation: 'page-spin 0.85s linear infinite' }}
      >
        <style>{`@keyframes page-spin { to { transform: rotate(360deg); } }`}</style>
        <circle
          cx="24" cy="24" r="20"
          stroke="var(--outline-variant)"
          strokeWidth="4"
        />
        <path
          d="M24 4a20 20 0 0 1 20 20"
          stroke="var(--primary)"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <span style={{ fontSize: '0.85rem', fontWeight: 600, letterSpacing: '0.06em' }}>
        {label}
      </span>
    </div>
  );
}

export default PageLoader;
